import { useSelector, } from 'react-redux';
import { IGlobalStore, IReducerStore, } from '@Store';

export const useResetConversationList = (): IGlobalStore['reset_conversation_list'] => {
  return useSelector((store: IReducerStore) => store.global.reset_conversation_list);
};
